export interface DeviceDetectionResult {
  fingerprint: string;
  deviceType: string;
  deviceModel: string | null;
  platform: string | null;
  userAgent: string;
  screenWidth: number | null;
  screenHeight: number | null;
}

type UADataNavigator = Navigator & {
  userAgentData?: {
    platform?: string;
    mobile?: boolean;
    getHighEntropyValues?: (hints: string[]) => Promise<Record<string, unknown>>;
  };
};

function detectDeviceType(userAgent: string, mobileHint: boolean | undefined): string {
  if (/ipad|tablet/i.test(userAgent)) return 'tablet';
  if (mobileHint || /iphone|android.+mobile|windows phone/i.test(userAgent)) return 'mobile';
  return 'desktop';
}

export async function detectDevice(): Promise<DeviceDetectionResult> {
  const nav = navigator as UADataNavigator;
  const userAgent = nav.userAgent ?? '';
  const userAgentData = nav.userAgentData;
  const screenWidth = typeof window !== 'undefined' ? window.screen.width : null;
  const screenHeight = typeof window !== 'undefined' ? window.screen.height : null;
  const deviceType = detectDeviceType(userAgent, userAgentData?.mobile);
  let deviceModel: string | null = null;
  let platform = userAgentData?.platform ?? nav.platform ?? null;

  if (typeof userAgentData?.getHighEntropyValues === 'function') {
    try {
      const values = await userAgentData.getHighEntropyValues(['model', 'platform']);
      deviceModel = typeof values.model === 'string' && values.model.trim() ? values.model : null;
      platform = typeof values.platform === 'string' && values.platform.trim() ? values.platform : platform;
    } catch {
      // best-effort only
    }
  }

  const fingerprint = [platform ?? 'unknown', deviceType, screenWidth ?? 0, screenHeight ?? 0]
    .join(':')
    .toLowerCase();

  return {
    fingerprint,
    deviceType,
    deviceModel,
    platform,
    userAgent,
    screenWidth,
    screenHeight,
  };
}
